import { paymentsApi } from '../httpService';


const getCustomerByReference = async (customerReferenceId: any) => {
    try {
        const result = await paymentsApi.get(`/api/v1/customers/references/${customerReferenceId}`, {});
        return {
            success: true,
            data: result.data.data,
            pager: result.data.pager
        };
    } catch (error: any) {
        if (error.response && error.response.status === 404) {
            return {
                success: false,
                notFound: true,
                message: "An unexpected Error"
            };
        }

        return {
            success: false,
            notFound: false,
            message: "An unexpected Error"
        };
    }
}



const getCustomersTransactionStats = async (query: any) => {
    try {
        const result = await paymentsApi.get(`/api/v1/customers/transactions/stats`, {
            params: query
        });

        return {
            success: true,
            data: result.data.data,
            pager: result.data.pager
        };
    } catch (error: any) {
        return {
            success: false,
            message: "An unexpected Error"
        };
    }
}



const getCustomersTransactionStatsByReference = async (query: any) => {
    try {
        const result = await paymentsApi.get(`/api/v1/customers/references/transactions/stats`, {
            params: query
        });

        return {
            success: true,
            data: result.data.data,
            pager: result.data.pager
        };
    } catch (error: any) {
        return {
            success: false,
            message: "An unexpected Error"
        };
    }
}



export default {
    getCustomerByReference,
    getCustomersTransactionStats,
    getCustomersTransactionStatsByReference,
}